import styled, { css } from "styled-components";
import Grid from "@material-ui/core/Grid";

import {
    regular as regularFontWeight,
    colors,
    breakpoints,
    H6New,
    H2New,
    spacing2020HasBreakpoints
} from "../index";

export const SectionHeadingGridItem = styled(Grid).attrs({ item: true })`
    &&& {
        padding-top: 0;
        padding-bottom: 0;
    }
`;

export const SectionHeading = styled(H2New)`
    ${spacing2020HasBreakpoints.Spacing4XL}
`;

export const BulletGridItem = styled(Grid)`
    ${H6New} {
        padding: 0;
        padding-top: 1.5rem; /* 24px */
        margin: 0;
        color: ${colors.dark};
    }

    @media (max-width: ${breakpoints.beforeTablet}rem) {
        ${SectionHeadingGridItem} + &&& {
            padding-top: 0;
        }
    }
`;

export const Paragraph = styled.p`
    padding: 0;
    padding-top: 1.5rem; /* 24px */
    margin: 0;
    ${regularFontWeight};
    color: ${colors.dark};
    font-size: 1rem; /* 16px */
    line-height: 1.625rem; /* 26px */

    /* Desktop - only: */
    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 308px;
    }
`;
